import React from "react";

const ChecvronDown = ({ style, className }) => {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      viewBox="0 0 32 32"
      stroke="currentColor"
      style={style}
    >
      <g id="Raggruppa_582" transform="translate(-1110 -723)">
        <path
          id="Tracciato_42"
          d="M3699.119,3315.081l10.133,10.133,10.133-10.133"
          transform="translate(-2583.619 -2581.58)"
          fill="none"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
        />
      </g>
    </svg>
  );
};

export default ChecvronDown;
